import React from 'react';
import loadHome from 'bundle-loader?lazy&name=home!./components/routes/home/home';
import loadCompanyErrorPage from 'bundle-loader?lazy&title=CompanyErrorPage!./components/routes/company-error/company-error';
import loadEditTopicsPage from 'bundle-loader?lazy&name=EditTopic!./components/routes/edit/EditTopic';
import { GOLD_COMPANY_ID } from './constants';

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [
    {
        title: 'Tributary Studio',
        pattern: '/:companyId/topics',
        load: loadHome,
    },
    {
        title: 'Tributary Studio',
        pattern: '/:companyId',
        load: loadCompanyErrorPage,
    },
    {
        title: 'Tributary Studio',
        pattern: '/',
        load: loadCompanyErrorPage,
    },
    {
        title: 'Tributary Studio',
        pattern: '/:companyId/topics/:topicName',
        load: loadEditTopicsPage,
    }
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;
    
    if ( match && !match.render && typeof match.load === 'function' ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ? asyncModule.default : asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}

export const redirectMiddleware = [
    // If the user lands on the Home page without a selected company in the URL, redirect
    // them to the Gold company by default.
    ( action, nextRoute, prevRoute ) => {
        if ( nextRoute.pathname === '/' ) {
            action.redirect( `/${ GOLD_COMPANY_ID }` );
        } else {
            action.ok();
        }
    },

    // If the user is on the Home page for a company, redirect them to the Topics page
    // since we don't have any other parts of the site to offer at the moment.
    ( action, nextRoute, prevRoute ) => {
        const companyId = nextRoute?.state?.params?.companyId;
        if ( nextRoute.pathname === `/${ companyId }` ) {
            action.redirect( `/${ companyId }/topics` );
        } else {
            action.ok();
        }
    }
];
